<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      คอร์สเรียน
    </h1>
  </div>
  <div class="row d-flex flex-row-reverse bd-highlight mb-4">
    <div class="container">
      <select class="custom-select form-control col-lg-3 col-md-4 col-sm-5 col-12" [(ngModel)]="selectedType"
        (change)="changeType()" style="float:right;">
        <option value="all">คอร์สทั้งหมด</option>
        <option value="mycourse">คอร์สของฉัน</option>
        <option value="newcourse">คอร์สใหม่</option>
        <option value="skilltree">Skill Tree</option>
      </select>
    </div>
  </div>
  <div class="row mt-3 mb-3" *ngIf="rows?.length === 0">
    <h2 class="text-center w-100">
      ยังไม่มีคอร์สเรียน
    </h2>
  </div>
  <div *ngIf="rows?.length > 0">
    <div class="row" *ngIf="selectedType === 'all' || selectedType === 'newcourse'">
      <div *ngFor="let c of rows" class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" (onFaverite)="onFaverite(c.COURSE_ID, c.IS_FAVORITE)"
          [title]="c.COURSE_NAME" [imageUrl]="c.COURSE_PIC" [haveFavorite]="true" [isFavorite]="c.IS_FAVORITE"
          [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE" [premiumPrice]="c.COURSE_SPECIALPRICE"
          [isPremium]="c.IS_PREMIUM" [isPaid]="false" style="outline: none;">
        </lifedi-course-card>
      </div>
    </div>
    <div class="row" *ngIf="selectedType === 'mycourse'">
      <div *ngFor="let c of rows" class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <lifedi-course-card (viewCourse)="viewCourse(c.COURSE_ID)" (onFaverite)="onFaverite(c.COURSE_ID, c.IS_FAVORITE)"
          [title]="c.COURSE_NAME" [imageUrl]="c.COURSE_PIC" [haveFavorite]="true" [isFavorite]="c.IS_FAVORITE"
          [teacherName]="c.USERNAME" [price]="c.COURSE_PRICE" [premiumPrice]="c.COURSE_SPECIALPRICE"
          [isPremium]="c.IS_PREMIUM" [isPaid]="true" style="outline: none;">
        </lifedi-course-card>
      </div>
    </div>
  </div>
  <div *ngIf="rows?.length > 0">
    <div *ngIf="selectedType === 'skilltree'">
      <lifedi-symbol-skill-tree class="mb-1"></lifedi-symbol-skill-tree>
      <div *ngFor="let skilltree of rows; let i = index;" class="mt-3 mb-4">
        <h2 class="text-center">{{skilltree.TREE_NAME}}</h2>
        <lifedi-skill-tree [nodes]="skilltree?.NODES" [clusters]="skilltree?.CLUSTER_NODES" [links]="skilltree?.LINKS">
        </lifedi-skill-tree>
      </div>

    </div>
  </div>

  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>

<div [ngClass]="rows?.length > 0 ? '' : 'footer'" >
  <lifedi-footer *ngIf="rows"></lifedi-footer>
</div>